import React from 'react'
import styled from 'styled-components'
import system from './system'
import { Link as BaseLink } from 'react-router-dom'
import { omit } from 'lodash'

const omitlist = [
  'css',
  'is',
  'isActive',
  'getProps',
  'exact',
  'color',
  'bg',
  'm',
  'mx',
  'my',
  'mt',
  'mb',
  'mr',
  'ml',
  'p',
  'px',
  'py',
  'flex',
]

const CleanRouterLink = React.forwardRef((props, ref) => {
  const cleanprops = omit(props, omitlist)
  return <BaseLink {...cleanprops} ref={ref} />
})

export const Link = system(
  { extend: CleanRouterLink },
  { textDecoration: 'none' },
  'color',
  'space',
)

const CleanExternalLinkInner = React.forwardRef((props, ref) => {
  const cleanprops = omit(props, omitlist)
  return <a {...cleanprops} ref={ref} />
})

export const CleanExternalLink = system(
  { extend: CleanExternalLinkInner },
  { textDecoration: 'none' },
  'color',
  'space',
)

// `Link` is built with our local system() helper, which - unlike @rebass/components'
// system() - does NOT apply an instance-level `css` prop (it gets omitted before it
// reaches the DOM). So the circle/size/focus styles have to be applied through a
// real styled-component wrapper, otherwise consumers like the sidebar CloseLink
// silently lose their width/height and stretch to fill their flex parent.
const CircleLink = styled(Link).withConfig({
  shouldForwardProp: (prop) => prop !== 'styleOverrides',
})(({ styleOverrides }) => styleOverrides)

export const LinkWithCircle = ({
  color,
  size,
  css = {},
  to = '../',
  ...rest
}) => (
  <CircleLink
    to={to}
    color={color}
    role="button"
    styleOverrides={{
      borderRadius: '100px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: `1px solid transparent`,
      svg: { display: 'block' },
      '&:focus': {
        outline: 'none',
      },
      '&:focus-visible': {
        border: `1px solid ${color}`,
      },
      ...css,
    }}
    {...rest}
  />
)

export const LinkInRoundedFocusBox = (props) => (
  <LinkWithCircle {...props} css={{ borderRadius: '5px' }} />
)

export const IconLink = React.memo(({ isActive, icon: Icon, ...rest }) => (
  <LinkInRoundedFocusBox p={0} m={0} {...rest}>
    <Icon active={!isActive} />
  </LinkInRoundedFocusBox>
))
